import { render, staticRenderFns } from "./TeacherSchoolFormView.vue?vue&type=template&id=e6374766&scoped=true"
import script from "./TeacherSchoolFormView.vue?vue&type=script&lang=js"
export * from "./TeacherSchoolFormView.vue?vue&type=script&lang=js"
import style0 from "./TeacherSchoolFormView.vue?vue&type=style&index=0&id=e6374766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6374766",
  null
  
)

export default component.exports